import { createContext, useContext } from 'react';

interface CellulaInputSelectContextValue {
	readOnly: boolean;
	invalid: boolean;
	isOpen: boolean;
	setIsOpen: (value: boolean) => void;
}

export const CellulaInputSelectContext = createContext<CellulaInputSelectContextValue>({
	readOnly: false,
	invalid: false,
	isOpen: false,
	// biome-ignore lint/suspicious/noEmptyBlockStatements: suppressed due to migration - should be fixed
	setIsOpen: () => {},
});

export function useInputSelectContext(): CellulaInputSelectContextValue {
	const context = useContext(CellulaInputSelectContext);
	if (!context) throw new Error('useInputSelectContext must be used within a CellulaSelectContext');

	return context;
}
